var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.45966 1.05027C6.85518 0.398209 7.56247 0 8.32511 0C9.08775 0 9.79504 0.398209 10.1926 1.05373L16.3586 11.3474C16.7462 12.0188 16.7485 12.8454 16.3646 13.5189C15.9807 14.1924 15.2683 14.6116 14.4851 14.6202L2.15712 14.6201C1.38193 14.6116 0.66948 14.1924 0.285582 13.5189C-0.0983163 12.8454 -0.0960017 12.0188 0.29757 11.3374L6.45966 1.05027ZM8.94693 1.80463C8.81509 1.58728 8.57932 1.45455 8.32511 1.45455C8.0709 1.45455 7.83513 1.58728 7.70538 1.80117L1.55128 12.0748C1.42206 12.2985 1.42129 12.5741 1.54926 12.7986C1.67722 13.0231 1.91471 13.1628 2.16511 13.1656L14.4771 13.1657C14.7355 13.1628 14.973 13.0231 15.101 12.7986C15.2289 12.5741 15.2282 12.2985 15.1048 12.0848L8.94693 1.80463ZM8.32511 4.43836C8.6933 4.43836 8.99759 4.71196 9.04574 5.06695L9.05238 5.16563V8.07472C9.05238 8.47639 8.72677 8.802 8.32511 8.802C7.95692 8.802 7.65263 8.52839 7.60448 8.17341L7.59784 8.07472V5.16563C7.59784 4.76397 7.92345 4.43836 8.32511 4.43836ZM9.05966 10.9838C9.05966 10.5822 8.73404 10.2565 8.33238 10.2565L8.22642 10.2632C7.87144 10.3113 7.59784 10.6156 7.59784 10.9838C7.59784 11.3855 7.92345 11.7111 8.33238 11.7111L8.43107 11.7044C8.78605 11.6563 9.05966 11.352 9.05966 10.9838Z",
    fill: "#FF4550"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAlert);
export default __webpack_public_path__ + "static/media/redAlert.bb60955b3f45566a7b87152808bf5024.svg";
export { ForwardRef as ReactComponent };